import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowTriangleIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 6 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.70885 2.66137C5.31591 3.05567 5.31591 3.94433 4.70885 4.33863L1.54471 6.3938C0.879434 6.8259 1.55626e-07 6.34846 1.90302e-07 5.55517L3.6997e-07 1.44483C4.04646e-07 0.651542 0.879434 0.174094 1.54471 0.606201L4.70885 2.66137Z",
		fill: "currentColor"
	})
});
export default SvgArrowTriangleIcon;
